export const allowedDomains = [
  "smile-world.fr",
  "smileevent.fr",
  "laser-world.fr",
  "erigea-loisirs.com",
  "erigea.com",
  "vertical-world.fr",
  "climb-world.fr",
];

